<template>
	<div class="jiufen">
		<div class="jiufenC">纠纷处理方式</div>
		<div class="jiufneCint">我公司按照文化部的相关要求，在网站的醒目位置标明纠纷处理方式。用户在注册、登陆本平台账号前请务必仔细阅读本《纠纷处理方式》（未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受本平台服务的同时维护自身合法权益：</div>
		<div class="jiufneCint" style="font-weight: bold;">用户之间纠纷处理方式</div>
		<div class="jiufneCint">1、深圳摩米贝尔网络信息技术有限公司仅作为本平台的运营商，如若本平台用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。深圳摩米贝尔网络信息技术有限公司将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。</div>
		<div class="jiufneCint">2、本平台用户之间发生纠纷的，也可向深圳摩米贝尔网络信息技术有限公司的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他深圳摩米贝尔网络信息技术有限公司要求提供的相关证据。经深圳摩米贝尔网络信息技术有限公司审核确认后，可以给予必要的协助和支持。</div>
		<div class="jiufneCint" style="font-weight: bold;">用户与深圳摩米贝尔网络信息技术有限公司之间纠纷处理方式</div>
		<div class="jiufneCint">1.如本平台用户对深圳摩米贝尔网络信息技术有限公司的服务有任何异议的，可以向深圳摩米贝尔网络信息技术有限公司的客服人员投诉并举证。查证属实的，深圳摩米贝尔网络信息技术有限公司将立即更正并按照现行法律规定给予用户必要的补偿。</div>
		<div class="jiufneCint">2.如本平台用户对深圳摩米贝尔网络信息技术有限公司的服务有任何异议的，也可以向双方约定（具体参见《深圳摩米贝尔网络信息技术有限公司网站使用协议》）的深圳摩米贝尔网络信息技术有限公司所在地人民法院提起诉讼。</div>
	</div>
</template>

<script>
export default {
	data () {
		return{
			
		}
	},
	mounted() {
		window.scroll(0, 0); 
	}
}
</script>

<style>
</style>
